import { c as _c } from "react/compiler-runtime";
import { Expandable, Heading, LayoutStack } from 'design-system/client';
import { useTranslations } from 'next-intl';
import { type ReactNode, useEffect } from 'react';
import styles from './AddressFieldToggle.module.css';
import I18nHtml from '@/components/I18nHtml';
import DonationFormField from '@/donationPages/_dependencies/components/DonationFormField';
import { useDonationFormContext, useDonationFormValues } from '@/donationPages/_dependencies/helpers';
import FormCheckbox from '@/form/FormCheckbox';
function AddressFieldToggle(t0) {
  const $ = _c(16);
  const {
    children
  } = t0;
  const {
    setValue
  } = useDonationFormContext();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["receipt_desired"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [receiptDesired] = useDonationFormValues(t1);
  const t = useTranslations("nextjs.donate");
  let t2;
  let t3;
  if ($[1] !== receiptDesired || $[2] !== setValue) {
    t2 = () => {
      if (receiptDesired) {
        return;
      }
      setValue("street", "", {
        shouldValidate: true
      });
      setValue("zip", "", {
        shouldValidate: true
      });
      setValue("city", "", {
        shouldValidate: true
      });
    };
    t3 = [receiptDesired, setValue];
    $[1] = receiptDesired;
    $[2] = setValue;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== t) {
    t4 = t("donation_receipt");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <Heading level="heading-xs" className={styles.headingMargin}>{t4}</Heading>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <DonationFormField name="receipt_desired" id="receiveReceipt" as={FormCheckbox}><I18nHtml i18nKey="donate.receipt_desired_html" /></DonationFormField>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = receiptDesired && children;
  let t8;
  if ($[10] !== receiptDesired || $[11] !== t7) {
    t8 = <LayoutStack space="200">{t6}<Expandable open={receiptDesired}>{t7}</Expandable></LayoutStack>;
    $[10] = receiptDesired;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t5 || $[14] !== t8) {
    t9 = <>{t5}{t8}</>;
    $[13] = t5;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
}
export default AddressFieldToggle;